/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import "assets/css/argon-dashboard-react.css";
import Moment from 'moment';
import { version } from "../../../package.json";
import { isOwner } from "views/member/memberApi.js";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col
} from "reactstrap";

var ps;

class Sidebar extends React.Component {
  state = {
    level: sessionStorage.getItem('level'),
    name: sessionStorage.getItem('name'),
    commission: sessionStorage.getItem('commission'),
    linkurl: "http://crm.mewahtrans.com.my/api/mewahapicode.php?",
    //imageurllink:"http://crm.mewahtrans.com.my/img/profile_img/",   

  }


  constructor(props) {
    super(props);
    this.activeRoute.bind(this);

  }

  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  // toggles collapse between opened and closed (true/false)
  toggleCollapse = () => {
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  // closes the collapse
  closeCollapse = () => {
    this.setState({
      collapseOpen: false
    });
  };
  // toggles a sidebar dropdown group (e.g. Membership, Marketing)
  toggleGroup = (group, isOpen) => {
    this.setState({ ['group_' + group]: !isOpen });
  };
  // whether a route should appear in the sidebar for the current user
  isVisible = prop => {
    if (prop.ownerOnly && !isOwner()) {
      return false;
    }
    var hidden = ["/", "/addnewquotation", "/addnewrot", "/forgetpassword", "/login", "/register", "/user-profile"];
    if (sessionStorage.getItem('level') != "Admin") {
      hidden = hidden.concat(["/PaymentSummary", "/report", "/comission"]);
    }
    return hidden.indexOf(prop.path) === -1;
  };
  createLink = (prop, key, className) => {
    return (
      <NavItem key={key}>
        <NavLink
          to={prop.layout + prop.path}
          tag={NavLinkRRD}
          onClick={this.closeCollapse}
          activeClassName="active"
          className={className}
        >
          <i className={prop.icon} />
          {prop.sidebarName || prop.name}
        </NavLink>
      </NavItem>
    );
  };
  // creates the links that appear in the left menu / Sidebar.
  // Routes sharing a `group` are shown together under one collapsible dropdown.
  createLinks = routes => {
    const groupIcons = { Membership: "ni ni-badge text-blue", Marketing: "ni ni-send text-blue" };
    const shownGroups = {};
    return routes.map((prop, key) => {
      if (!prop.group) {
        return this.isVisible(prop) ? this.createLink(prop, key) : null;
      }
      if (shownGroups[prop.group]) {
        return null;
      }
      shownGroups[prop.group] = true;
      const children = routes.filter(r => r.group === prop.group && this.isVisible(r));
      if (children.length === 0) {
        return null;
      }
      const hasActive = children.some(r => this.props.location.pathname === r.layout + r.path);
      const stored = this.state['group_' + prop.group];
      const isOpen = stored === undefined ? hasActive : stored;
      return (
        <NavItem key={"group_" + prop.group}>
          <NavLink
            href="#"
            onClick={e => { e.preventDefault(); this.toggleGroup(prop.group, isOpen); }}
            className={"d-flex align-items-center" + (hasActive ? " text-primary" : "")}
          >
            <i className={groupIcons[prop.group] || "ni ni-bullet-list-67 text-blue"} />
            <span className="flex-grow-1">{prop.group}</span>
            <i className={"fas fa-chevron-" + (isOpen ? "up" : "down")} style={{ fontSize: 10, minWidth: 0 }} />
          </NavLink>
          <Collapse isOpen={isOpen}>
            <Nav className="nav-sm flex-column">
              {children.map((child, i) => this.createLink(child, prop.group + i, "pl-5"))}
            </Nav>
          </Collapse>
        </NavItem>
      );
    });
  };

  componentDidMount() {
    this.interval = setInterval(() => {
      var datetemp = new Date().getDate()
      var monthtemp = new Date().getMonth() + 1
      var yeartemp = new Date().getFullYear()
      var hourtemp = new Date().getHours()
      var minutemp = new Date().getMinutes()
      var secondtemp = new Date().getSeconds()
      this.setState({ date: yeartemp + '-' + ('0' + monthtemp).slice(-2) + '-' + ('0' + datetemp).slice(-2) + 'T' + ('0' + hourtemp).slice(-2) + ':' + ('0' + minutemp).slice(-2) + ':' + ('0' + secondtemp).slice(-2) })
    }, 1000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }


  render() {
    const imgurl = this.state.imageurllink + this.state.profileimageurl
    Moment.locale('en');
    var dt = this.state.date;
    const { bgColor, routes, logo } = this.props;
    let navbarBrandProps;
    if (logo && logo.innerLink) {
      navbarBrandProps = {
        to: logo.innerLink,
        tag: Link
      };
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: "_blank"
      };
    }
    return (
      <Navbar
        className="navbar-vertical fixed-left navbar-light bg-white"
        expand="md"
        id="sidenav-main"
      >
        <Container fluid>
          {/* Toggler */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={this.toggleCollapse}
          >
            <span className="navbar-toggler-icon" />
          </button>
          {/* Brand */}
          {logo ? (
            <NavbarBrand className="pt-1" {...navbarBrandProps}>
              <Link to="/admin/dashboard" className="h3 font-weight-bold text-primary" style={{ textDecoration: 'none' }}>
                MZ Pro Trading
              </Link>
            </NavbarBrand>
          ) : null}
          {/* User */}
          <Nav className="align-items-center d-sm-none">
            {/* <UncontrolledDropdown nav>
              <DropdownToggle nav className="nav-link-icon">
                <i className="ni ni-bell-55" />
              </DropdownToggle>
              <DropdownMenu
                aria-labelledby="navbar-default_dropdown_1"
                className="dropdown-menu-arrow"
                right
              >
                <DropdownItem>Action</DropdownItem>
                <DropdownItem>Another action</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>Something else here</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown> */}
            <UncontrolledDropdown nav>
              <DropdownToggle nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img
                      alt="..."
                      src={imgurl}
                    />
                  </span>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>

                <DropdownItem divider />
                <DropdownItem href="#pablo" to="/auth/login" tag={Link} >
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
          {/* Collapse */}
          <Collapse navbar isOpen={this.state.collapseOpen}>
            {/* Collapse header */}
            <div className="navbar-collapse-header d-sm-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to={logo.innerLink} onClick={this.toggleCollapse} className="h3 font-weight-bold text-primary" style={{ textDecoration: 'none' }}>
                        MZ Pro Trading
                      </Link>
                    ) : (
                      <a href={logo.outterLink} onClick={this.toggleCollapse} className="h3 font-weight-bold text-primary" style={{ textDecoration: 'none' }}>
                        MZ Pro Trading
                      </a>
                    )}
                  </Col>
                ) : null}
                <Col className="collapse-close" xs="3">
                  <button
                    className="navbar-toggler "
                    type="button"
                    onClick={this.toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            {/* Form */}
            {/* <Form className="mt-4 mb-3 d-md-none">
              <InputGroup className="input-group-rounded input-group-merge">
                <Input
                  aria-label="Search"
                  className="form-control-rounded form-control-prepended"
                  placeholder="Search"
                  type="search"
                />
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <span className="fa fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </Form> */}
            {/* Navigation */}
            <Nav navbar>{this.createLinks(routes)}</Nav>
            {/* Divider */}
            <hr className="my-3" />
            {/*Show Date Time */}
            <h6 className="navbar-heading text-muted aligntobottomtime" style={{ bottom: 10, minWidth: 100 }}>
              {Moment(dt).format('HH:mm:ss')} <br /> {Moment(dt).format('dddd')}  <br /> {Moment(dt).format('DD MMM YYYY')}
              <br />  <span style={{ fontSize: '10px' }}>v{version}</span>
            </h6>


          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

Sidebar.defaultProps = {
  routes: [{}]
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired
  })
};

export default Sidebar;
